// #region dependencies
// #endregion
// #region constant
// #endregion
// #region common
import BaseServiceRetryWrapper from './baseRetry';
import { ALLOCATIONS } from '../common/endpoints';
// #endregion

class AllocationsService extends BaseServiceRetryWrapper {
  /**
   * @function
   * @name dataById
   * @description load captable by id selected.
   * @param {INTEGER} dataId the captable id
   */
  dataById = (dataId: number, exchangeRate: string) =>
    this.get(`${ALLOCATIONS.byId}/${dataId}?exchange_rate=${exchangeRate}`);

  /**
   * @function
   * @name updateDataById
   * @description update allocation by id selected.
   * @param {INTEGER} dataId the allocation id
   * @param {OBJECT} data the allocation data structure to send
   */
  updateDataById = (dataId: number, data: unknown) => this.put(`${ALLOCATIONS.updateById}/${dataId}`, data);

  postScenarioValues = (data: unknown) => this.post(ALLOCATIONS.postScenarioValues, data);

  publishById = (dataId: number) => this.put(`${ALLOCATIONS.publishAllocation}/${dataId}/published`);

  makeFinal = (ids: string[]) => this.put(ALLOCATIONS.makeFinal(ids));

  calculateBacksolveEquityValue = (data: unknown) => this.post(ALLOCATIONS.calculateBacksolveEquityValue, data);

  /**
   * @function
   * @name getRiskFreeRate
   * @description Get risk free rate based on maturity and measurement date.
   * @param {INTEGER} maturity The maturity value.
   * @param {INTEGER} measurementDateID The measurement date id.
   */
  getRiskFreeRateByDate = (maturity: string, queryDate: string) =>
    this.get(ALLOCATIONS.getRiskFreeRateByDate(maturity, queryDate));
}

export default AllocationsService;
